import { useDispatch } from 'react-redux';
import tenantAxiosInstance from '../utils/tenantAxiosInstance';
import { setMessage } from '../slices/alertMessageSlice';
const API_URL = process.env.REACT_APP_BACKEND_URL;
const version = 'v1';




const createNewJobUpload = async (tenant_id, body) => {
  return tenantAxiosInstance
    ?.post(API_URL + `data_ingestion/${tenant_id}`, body)
    .then((response) => {
      // console.log(response);
      return response.data;
    })
    .catch((error) => {
      throw error;
    });
};


const getOperationDataPert = async (tenant_id,body ) => {
  return tenantAxiosInstance
    ?.post(
      API_URL + `operation_data_get_all/${tenant_id}`,body
    )
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      throw error;
    });
};

const getOperationDateData = async (tenant_id,body ) => {
  return tenantAxiosInstance
    ?.post(
      API_URL + `date_based_filter_child_data/${tenant_id}`,body
    )
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      throw error;
    });
};



const updateOperationDataPert = async (tenant_id,body ) => {
  return tenantAxiosInstance
    ?.patch(
      API_URL + `update/${tenant_id}`,body
    )
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      throw error;
    });
};


const deleteOperationData = async (tenant_id ,dname) => {
  return tenantAxiosInstance
    ?.delete(
      API_URL + `delete_operation_data/${tenant_id}/${dname}`
    )
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      throw error;
    });
};



const getOperationData = async (tenant_id ) => {
  return tenantAxiosInstance
    ?.get(
      API_URL + `operation_data_list/${tenant_id}`
    )
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      throw error;
    });
};

const OperationService = {
  
  createNewJobUpload,
  getOperationData,
  getOperationDataPert,
  updateOperationDataPert,
  deleteOperationData,
  getOperationDateData
};
export default OperationService;
